export default __webpack_public_path__ + "static/IMG_9194-9bf26b3786dc56941b1868effbb634a6.jpg";